export enum KnmDocumentsActionsEnum {
  KNM_DOCUMENTS_UPLOAD = 'KNM_DOCUMENTS_UPLOAD',
  KNM_DOCUMENTS_SAVE_SIGNED_DOCUMENT = 'KNM_DOCUMENTS_SAVE_SIGNED_DOCUMENT',
  KNM_DOCUMENTS_DOWNLOAD = 'KNM_DOCUMENTS_DOWNLOAD',
}
